import { useEffect, useState } from 'react'

/**
 * Est-ce qu'on joue au doigt ?
 *
 * Toute une partie de l'interface repose sur le survol : la poupée, la carte et
 * le négoce écrivent le détail de ce qu'on vise dans un panneau fixe. Au doigt,
 * le survol n'existe pas, et un appui déclencherait directement l'action sans
 * qu'on ait jamais pu lire ce qu'on allait faire.
 *
 * D'où la règle, la même partout : **au doigt, un appui vise, un second agit.**
 * À la souris, rien ne change, le survol vise et le clic agit.
 *
 * On teste `hover: none` plutôt que la largeur d'écran : c'est la capacité du
 * pointeur qui compte, pas la taille. Une tablette large se joue au doigt, un
 * petit portable se joue à la souris.
 */
export function useAuDoigt(): boolean {
  const [auDoigt, setAuDoigt] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(hover: none)').matches,
  )

  useEffect(() => {
    const requete = window.matchMedia('(hover: none)')
    const suivre = () => setAuDoigt(requete.matches)
    requete.addEventListener('change', suivre)
    return () => requete.removeEventListener('change', suivre)
  }, [])

  return auDoigt
}
